import { inject,Injectable } from '@angular/core';
import { DpModalService, HeaderAction } from '@docpath/webcomponents';
import { faMagnifyingGlass, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import { IndexService } from '../../models/index-service';
import { IndexServicesService } from '../../services/index-services.service';
import { IndexServicesFormService } from '../../services/index-services-form.service';
import { IndexServicesHttpService } from '../../services/index-services-http.service';


@Injectable({
    providedIn: 'root'
})
export class IndexServicesHeaderService {

    private readonly i18nPrefix = 'services-config.index-services';

    private readonly indexServicesService = inject(IndexServicesService);
    private readonly indexServicesHttpService = inject(IndexServicesHttpService);
    private readonly indexServicesFormsService = inject(IndexServicesFormService);
    private readonly modalService = inject(DpModalService);

    getRightActions(): HeaderAction[] {
        return [
            this.initNewIndexServiceAction(),
            this.initSearchAction()
        ];
    }

    getMoreActions(selectedIndexServices: IndexService[]): HeaderAction[] {
        const actions = [];

        if (selectedIndexServices.length > 0) {
            actions.push(this.initDeleteAction(selectedIndexServices));
            actions.push(this.initUpdateAction(selectedIndexServices));
        }

        return actions;
    }

    getLeftActions(selectedIndexServices: IndexService[]): HeaderAction[] {
        const actions = [];

        if (selectedIndexServices.length > 0) {
            if (selectedIndexServices.length === 1) {
                const indexService = selectedIndexServices[0];
                actions.push(this.initEditAction(indexService));
            }
        }

        return actions;
    }

    getSearchAction(actions: HeaderAction[]): HeaderAction {
        return actions[1];
    }

    private initSearchAction(): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.search.label`, { cssClass: 'btn btn-dpsecondary' });

        action.icon = faMagnifyingGlass;
        action.tooltip = `${this.i18nPrefix}.header.search.tooltip`;

        return action;
    }

    private initNewIndexServiceAction(): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.new-index-service.label`);

        action.icon = faPlusCircle;
        action.tooltip = `${this.i18nPrefix}.header.new-index-service.tooltip`;
        action.action = () => this.indexServicesFormsService.openCreationIndexServiceForm();

        return action;
    }

    private initEditAction(indexService: IndexService): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.edit.label`);

        action.tooltip = `${this.i18nPrefix}.header.edit.tooltip`;
        action.action = () => this.indexServicesFormsService.openEditIndexServiceForm(indexService);

        return action;
    }

    private initDeleteAction(indexServices: IndexService[]): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.delete.label`);

        action.tooltip = `${this.i18nPrefix}.header.delete.tooltip`;
        action.action = () => this.deleteIndexServices(indexServices);

        return action;
    }

    private deleteIndexServices(indexServices: IndexService[]): void {
        const indexServiceIds = indexServices.map(indexService => indexService.id),
            modal = this.modalService.openQuestion(`${this.i18nPrefix}.modal.delete-question`);

        modal.componentInstance.accepted.subscribe(() => {
            this.deleteIndexServicesRequest(indexServiceIds);
        });
    }

    private deleteIndexServicesRequest(indexServiceIds: number[]): void {
        this.indexServicesHttpService.deleteIndexServices(indexServiceIds, () => {
            this.indexServicesService.notifyIndexServicesChange();
        });
    }


    private initUpdateAction(indexServices: IndexService[]): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.update.label`);

        action.tooltip = `${this.i18nPrefix}.header.update.tooltip`;
        action.action = () => this.updateIndexService(indexServices);

        return action;
    }

    private updateIndexService(indexServices: IndexService[]): void {
        const indexServiceIds = indexServices.map(indexService => indexService.id);
        this.updateIndexServiceRequest(indexServiceIds);
    }


    private updateIndexServiceRequest(indexServiceIds: number[]): void {
        this.indexServicesHttpService.updateIndexServices(indexServiceIds, () => {
            this.indexServicesService.notifyIndexServicesChange();
        });
    }

}